import { useCallback } from 'react';

/** Selects the entire word at the double-click position. */
const useHandleSelectWordAtCaret = () => {
  return useCallback((e: React.MouseEvent<HTMLInputElement>) => {
    const input = e.currentTarget;
    const pos = document.caretPositionFromPoint(e.clientX, e.clientY);
    if (!pos) return;

    const value = input.value;
    const offset = pos.offset;

    let start = offset;
    let end = offset;
    while (start > 0 && /\w/.test(value[start - 1])) start--;
    while (end < value.length && /\w/.test(value[end])) end++;

    input.setSelectionRange(start, end);
  }, []);
};

export default useHandleSelectWordAtCaret;
